const weaponHiddenPowerData = {
    common: {
        None: [0],
        ATKPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        HPPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        DEFPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        CritRate: [8.25, 8.4, 8.55, 8.7, 8.85, 9],
        CritDMG: [13.75, 14, 14.25, 14.5, 14.75, 15],
        ElementalATK: [35, 36, 37, 38, 39, 40],
    },
    uncommon: {
        ATKPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        HPPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        DEFPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        CritRate: [9.75, 9.9, 10.05, 10.2, 10.35, 10.5],
        CritDMG: [16.25, 16.5, 16.75, 17, 17.25, 17.5],
        ElementalATK: [45, 46, 47, 48, 49, 50],
    },
    rare: {
        ATKPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        HPPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        DEFPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        CritRate: [11.25, 11.4, 11.55, 11.7, 11.85, 12],
        CritDMG: [18.75, 19, 19.25, 19.5, 19.75, 20],
        ElementalATK: [55, 56, 57, 58, 59, 60],
    },
    epic: {
        ATKPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        HPPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        DEFPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        CritRate: [12.75, 12.9, 13.05, 13.2, 13.35, 13.5],
        CritDMG: [21.25, 21.5, 21.75, 22, 22.25, 22.5],
        ElementalATK: [65, 66, 67, 68, 69, 70],
    },
    superEpic: {
        ATKPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        HPPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        DEFPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        CritRate: [14.25, 14.4, 14.55, 14.7, 14.85, 15],
        CritDMG: [23.75, 24, 24.25, 24.5, 24.75, 25],
        ElementalATK: [75, 76, 77, 78, 79, 80],
    },

};

const helmetHiddenPowerData = {
    common: {
        None: [0],
        ATKPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        HPPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        DEFPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        CritRate: [8.25, 8.4, 8.55, 8.7, 8.85, 9],
        CritDMG: [13.75, 14, 14.25, 14.5, 14.75, 15],
        ElementalDMG: [8.25, 8.4, 8.55, 8.7, 8.85, 9],
    },
    uncommon: {
        ATKPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        HPPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        DEFPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        CritRate: [9.75, 9.9, 10.05, 10.2, 10.35, 10.5],
        CritDMG: [16.25, 16.5, 16.75, 17, 17.25, 17.5],
        ElementalDMG: [9.75, 9.9, 10.05, 10.2, 10.35, 10.5],
    },
    rare: {
        ATKPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        HPPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        DEFPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        CritRate: [11.25, 11.4, 11.55, 11.7, 11.85, 12],
        CritDMG: [18.75, 19, 19.25, 19.5, 19.75, 20],
        ElementalDMG: [11.25, 11.4, 11.55, 11.7, 11.85, 12],
    },
    epic: {
        ATKPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        HPPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        DEFPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        CritRate: [12.75, 12.9, 13.05, 13.2, 13.35, 13.5],
        CritDMG: [21.25, 21.5, 21.75, 22, 22.25, 22.5],
        ElementalDMG: [12.75, 12.9, 13.05, 13.2, 13.35, 13.5],
    },
    superEpic: {
        ATKPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        HPPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        DEFPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        CritRate: [14.25, 14.4, 14.55, 14.7, 14.85, 15],
        CritDMG: [23.75, 24, 24.25, 24.5, 24.75, 25],
        ElementalDMG: [14.25, 14.4, 14.55, 14.7, 14.85, 15],
    },

};


const chestplateHiddenPowerData = {
    common: {
        None: [0],
        ATKPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        HPPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        DEFPercent: [11, 11.2, 11.4, 11.6, 11.8, 12],
        CritRate: [8.25, 8.4, 8.55, 8.7, 8.85, 9],
        CritDMG: [13.75, 14, 14.25, 14.5, 14.75, 15],
        BuffAmp: [5.5, 5.6, 5.7, 5.8, 5.9, 6],
        DebuffAmp: [5.5, 5.6, 5.7, 5.8, 5.9, 6],
        Healing: [8.8, 8.96, 9.12, 9.28, 9.44, 9.6],
        Shield: [8.8, 8.96, 9.12, 9.28, 9.44, 9.6],
        DEFPenetration: [4.4, 4.48, 4.56, 4.64, 4.72, 4.8],
        DamageReduction: [4.4, 4.48, 4.56, 4.64, 4.72, 4.8],
    },
    uncommon: {
        ATKPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        HPPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        DEFPercent: [13, 13.2, 13.4, 13.6, 13.8, 14],
        CritRate: [9.75, 9.9, 10.05, 10.2, 10.35, 10.5],
        CritDMG: [16.25, 16.5, 16.75, 17, 17.25, 17.5],
        BuffAmp: [6.5, 6.6, 6.7, 6.8, 6.9, 7],
        DebuffAmp: [6.5, 6.6, 6.7, 6.8, 6.9, 7],
        Healing: [10.4, 10.56, 10.72, 10.88, 11.04, 11.2],
        Shield: [10.4, 10.56, 10.72, 10.88, 11.04, 11.2],
        DEFPenetration: [5.2, 5.28, 5.36, 5.44, 5.52, 5.6],
        DamageReduction: [5.2, 5.28, 5.36, 5.44, 5.52, 5.6],
    },
    rare: {
        ATKPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        HPPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        DEFPercent: [15, 15.2, 15.4, 15.6, 15.8, 16],
        CritRate: [11.25, 11.4, 11.55, 11.7, 11.85, 12],
        CritDMG: [18.75, 19, 19.25, 19.5, 19.75, 20],
        BuffAmp: [7.5, 7.6, 7.7, 7.8, 7.9, 8],
        DebuffAmp: [7.5, 7.6, 7.7, 7.8, 7.9, 8],
        Healing: [12, 12.16, 12.32, 12.48, 12.64, 12.8],
        Shield: [12, 12.16, 12.32, 12.48, 12.64, 12.8],
        DEFPenetration: [6, 6.08, 6.16, 6.24, 6.32, 6.4],
        DamageReduction: [6, 6.08, 6.16, 6.24, 6.32, 6.4],
    },
    epic: {
        ATKPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        HPPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        DEFPercent: [17, 17.2, 17.4, 17.6, 17.8, 18],
        CritRate: [12.75, 12.9, 13.05, 13.2, 13.35, 13.5],
        CritDMG: [21.25, 21.5, 21.75, 22, 22.25, 22.5],
        BuffAmp: [8.5, 8.6, 8.7, 8.8, 8.9, 9],
        DebuffAmp: [8.5, 8.6, 8.7, 8.8, 8.9, 9],
        Healing: [13.6, 13.76, 13.92, 14.08, 14.24, 14.4],
        Shield: [13.6, 13.76, 13.92, 14.08, 14.24, 14.4],
        DEFPenetration: [6.8, 6.88, 6.96, 7.04, 7.12, 7.2],
        DamageReduction: [6.8, 6.88, 6.96, 7.04, 7.12, 7.2],
    },
    superEpic: {
        ATKPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        HPPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        DEFPercent: [19, 19.2, 19.4, 19.6, 19.8, 20],
        CritRate: [14.25, 14.4, 14.55, 14.7, 14.85, 15],
        CritDMG: [23.75, 24, 24.25, 24.5, 24.75, 25],
        BuffAmp: [9.5, 9.6, 9.7, 9.8, 9.9, 10],
        DebuffAmp: [9.5, 9.6, 9.7, 9.8, 9.9, 10],
        Healing: [15.2, 15.36, 15.52, 15.68, 15.84, 16],
        Shield: [15.2, 15.36, 15.52, 15.68, 15.84, 16],
        DEFPenetration: [7.6, 7.68, 7.76, 7.84, 7.92, 8],
        DamageReduction: [7.6, 7.68, 7.76, 7.84, 7.92, 8],
    },

};



const leggingsHiddenPowerData = chestplateHiddenPowerData

export  { 
    weaponHiddenPowerData,
    helmetHiddenPowerData,
    chestplateHiddenPowerData,
    leggingsHiddenPowerData
}